/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SenderInviteRequest
 */
export interface SenderInviteRequest {
    /**
     * 
     */
    phone: string;
}

/**
 * Check if a given object implements the SenderInviteRequest interface.
 */
export function instanceOfSenderInviteRequest(value: object): value is SenderInviteRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function SenderInviteRequestFromJSON(json: any): SenderInviteRequest {
    return SenderInviteRequestFromJSONTyped(json, false);
}

export function SenderInviteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SenderInviteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
    };
}

export function SenderInviteRequestToJSON(json: any): SenderInviteRequest {
    return SenderInviteRequestToJSONTyped(json, false);
}

export function SenderInviteRequestToJSONTyped(value?: SenderInviteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
    };
}

